import { isAfter, isBefore, parseISO, startOfDay } from 'date-fns'
import { createValidator, ErrorObject, maxLength, nomeFabricante, nomeLote, required } from 'util/validation'

import { LoteImunobiologicoFormModel } from '../insert/LoteImunologicoTooltipAddForm'
import { getLoteImunobiologicoMaxDate } from '../utils/utils-loteImunobiologico'

export const validateLoteImunobiologico = (dataMinimaValidadeLote: Date) =>
  createValidator<LoteImunobiologicoFormModel>(
    {
      lote: [required, maxLength(30), nomeLote],
      fabricante: [required, maxLength(60)],
      imunobiologico: [required],
      validade: [required],
    },
    (values: LoteImunobiologicoFormModel, errors: ErrorObject<LoteImunobiologicoFormModel>) => {
      if (!errors.fabricante && values?.fabricante?.nome) {
        const errorFabricanteImunoRule = nomeFabricante(values.fabricante.nome)
        if (errorFabricanteImunoRule) {
          errors.fabricante = errorFabricanteImunoRule
        }
      }

      validateDataValidadeLoteImunobiologico(values.validade, errors, 'validade', dataMinimaValidadeLote)

      return errors
    }
  )

export const validateDataValidadeLoteImunobiologico = <T>(
  dataValidadeValue: LocalDate,
  errors: ErrorObject<T>,
  fieldName: keyof T,
  dataAtendimento: Date
) => {
  const dataValidadeParsed = parseISO(dataValidadeValue)
  const maxDate = getLoteImunobiologicoMaxDate(dataAtendimento)

  if (isBefore(dataValidadeParsed, startOfDay(dataAtendimento))) {
    errors[fieldName] = 'Deve ser posterior ou igual à data atual'
  }

  if (isAfter(dataValidadeParsed, maxDate)) {
    errors[fieldName] = 'Deve ter no máximo 10 anos'
  }
}
